module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {}, [_c('section', {
    staticClass: "content-header "
  }, [(!_vm.editavel || _vm.editando === '') ? _c('h1', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "title": _vm.$route.params.numero + ' - ' + _vm.proposta.ds_nome
    }
  }, [_c('span', {
    staticStyle: {
      "max-width": "60%",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("Projeto " + _vm._s(_vm.$route.params.numero) + " - " + _vm._s(_vm.proposta.ds_nome))]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading) ? _c('span', [_vm._v("("), _c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm._.get(_vm.proposta, 'projetoSapiens.0.sitprj', '')))]), _vm._v(")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editavel && _vm.editando !== '') ? _c('h1', [_vm._v("Alterando " + _vm._s(_vm.editando.replace('_', ' ')) + "\n          "), (_vm.editando !== 'periodo_projeto') ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }]
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir(_vm.editando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelar(_vm.editando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.find(_vm.mostrar, function(k) {
    return k === true
  })) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-caret-down opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Abre todas as seções</h5>'
    },
    on: {
      "click": function($event) {
        Object.keys(_vm.mostrar).forEach(function (m) {
          _vm.mostrar[m] = true
        });
        _vm.$refs['proposta'].scrollIntoView()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.mostrar, function(k) {
    return k === true
  })) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-caret-up opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Fecha todas as seções</h5>'
    },
    on: {
      "click": function($event) {
        Object.keys(_vm.mostrar).forEach(function (m) {
          _vm.mostrar[m] = false
        });
        _vm.$refs['proposta'].scrollIntoView()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-angle-double-up opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Vai para o topo da página</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$refs['topo'].scrollIntoView()
      }
    }
  }), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-print opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>248 - Monitoramento Administrativo (PDF)</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('span', [_vm._v("Monitoramento Administrativo")])]) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-print opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>222 - Extrato de Projeto (PDF)</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.emitir(222)
      }
    }
  }, [_c('span', [_vm._v("Extrato de Projeto")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-print opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('span', [_vm._v("Adiantamentos")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-external-link opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Abrirá a tela de Relatórios de Execução desse projeto</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'visualiza-relatorio-execucao',
          params: {
            id: _vm.projeto.proposta.projeto.id
          }
        })
      }
    }
  }, [_c('span', [_vm._v("Relatórios de Execução")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-external-link opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Vai para tela de Alterações deste Projeto</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'solicitacao-alteracoes-projeto',
          params: {
            numero: _vm.proposta.ds_codigo_projeto_erp
          }
        })
      }
    }
  }, [_c('span', [_vm._v("Alterações de Projeto")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  }), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Projeto',
        href: '#'
      }, {
        text: _vm.$route.params.numero,
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    ref: "topo",
    staticClass: "content projetoAprovado"
  }, [_c('br'), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('visualiza-timeline', {
    attrs: {
      "numeroProjeto": _vm.$route.params.numero,
      "atualizar": _vm.atualizar_timeline
    },
    on: {
      "idAcompanhamento": function($event) {
        _vm.filtro_acompanhamento = $event
      },
      "idAlteracoes": function($event) {
        _vm.filtro_alteracoes = $event
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
    ref: "ocorrencias",
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.ocorrencias = !(_vm.mostrar.ocorrencias)
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.ocorrencias ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocorrências do Projeto ")])])]), _vm._v(" "), (_vm.mostrar.ocorrencias) ? _c('div', {
    staticClass: "box-body"
  }, [_c('edita-ocorrencias', {
    attrs: {
      "numeroProjeto": _vm.$route.params.numero,
      "itensLayout": ['botaoNovo', 'botaoExportarExcel', 'filtroNivelOcorrencia', 'filtroCodigoOcorrencia', 'filtroSituacaoOcorrencia', 'totalizador', 'colunaCodigo', 'colunaObservacao', 'colunaUsuarioCriador', 'colunaSituacao', 'colunaDataCriacao', 'colunaAcoes']
    },
    on: {
      "acaoOcorrencia": function($event) {
        _vm.ocorrenciaSelecionada = $event
      },
      "acaoProcessamento": function($event) {
        _vm.loading = true
      },
      "acaoAguardando": function($event) {
        _vm.loading = false
      },
      "acaoCancelar": function($event) {
        _vm.ocorrenciaSelecionada.id = null
      },
      "acaoOk": function($event) {
        _vm.loading = false
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
    ref: "alteracoes"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.alteracoes = !_vm.mostrar.alteracoes
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.alteracoes ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterações no Projeto")])])]), _vm._v(" "), (_vm.mostrar.alteracoes) ? _c('div', {
    staticClass: "box-body"
  }, [_c('alteracoesProjetos', {
    attrs: {
      "ParmProjetos": _vm.projeto,
      "ParmAlteracao": _vm.atProp,
      "filtro": _vm.filtro_alteracoes
    },
    on: {
      "atualizarTimeline": function($event) {
        _vm.atualizar_timeline = $event
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
    ref: "opcoesProjeto"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.opcoesProjeto = !_vm.mostrar.opcoesProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.opcoesProjeto ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Opções das alterações do projeto")])])]), _vm._v(" "), (_vm.mostrar.opcoesProjeto) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Passíveis de solicitação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "periodoProjeto"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "periodoProjeto") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "periodoProjeto",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Prorrogação de Prazo"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "metas"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "metas") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "metas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Metas"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "atividades"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "atividades") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "atividades",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Atividades"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "remanejamento"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "remanejamento") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "remanejamento",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Remanejamento"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "suplementacao"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "suplementacao") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "suplementacao",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Suplementação"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "parcelasAdiantamento",
      "disabled": _vm.proposta.adiantamentos.length === 0
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "parcelasAdiantamento") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "parcelasAdiantamento",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }
    }
  }), _vm._v(" Parcelas de Adiantamento"), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.opcoes.alteracoesPermitidas),
      expression: "proposta.opcoes.alteracoesPermitidas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "municipios"
    },
    domProps: {
      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "municipios") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "municipios",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
        }
      }, function($event) {
        return _vm.atualizaOpcoesAlteracoes()
      }]
    }
  }), _vm._v(" Municípios atendidos"), _c('div', {
    staticClass: "new-control-indicator"
  })])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "proposta"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-horizontal"
  }, [(false) ? _c('div', [_vm._v("\n                   Dados do Projeto\n\n                  "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.mostrarRef('projeto_numero')) ? _c('div', [_c('div', [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nº do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposta.ds_codigo_projeto_erp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_codigo_projeto_erp),
      expression: "proposta.ds_codigo_projeto_erp"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "idProjectErp",
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.proposta.ds_codigo_projeto_erp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_nome')) ? _c('div', [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_nome),
      expression: "proposta.ds_nome"
    }],
    staticClass: "form-control col",
    attrs: {
      "name": "nome",
      "data-vv-as": "Nome da Proposta",
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.proposta.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_nome", $event.target.value)
      }
    }
  })])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439) ? _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.entidade = !_vm.mostrar.entidade
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.entidade ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dados da Entidade")])])]), _vm._v(" "), (_vm.mostrar.entidade) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.proposta.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', [(_vm.proposta.entidade.endereco) ? _c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_numero) + " -\n                          " + _vm._s(_vm.proposta.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.proposta.entidade.endereco[0].ds_estado))]) : _c('div', [_vm._v("Sem endereço! Verificar o cadastro da entidade")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.telefone))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
    return _c('div', [_c('table', {
      staticClass: "table table-condensed table-bordered listaDirigentes"
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w30"
    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cargo")]), _vm._v(" "), (dirigente.cargo.ds_descricao) ? _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_estado_civil))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.endereco.ds_rua) + ", " + _vm._s(dirigente.endereco.ds_numero) + ", " + _vm._s(dirigente.endereco.ds_bairro) + ", " + _vm._s(dirigente.endereco.ds_complemento))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("CEP")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("cep")(dirigente.endereco.ds_cep)))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cidade/UF")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.endereco.ds_cidade) + " / " + _vm._s(dirigente.endereco.ds_uf))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.contato.ds_email))])])])])])
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'periodo_projeto') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.periodo = !_vm.mostrar.periodo
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.periodo ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Período de execução do projeto")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Período de execução do projeto")])])]), _vm._v(" "), (_vm.mostrar.periodo) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data inicial")]), _vm._v(" "), (_vm.editando === 'periodo_projeto' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>(!)Data de Assinatura do Convênio <br/></h5>'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.dt_assinatura_convenio),
      expression: "proposta.dt_assinatura_convenio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Data Inicial do Projeto",
      "lang": "pt-br",
      "name": "periodo",
      "type": "date",
      "disabled": (_vm.editando !== 'periodo_projeto' && _vm.usuarioLogado.userType === 'FUNDACAO' || !_vm.acessoGerSolucoes)
    },
    domProps: {
      "value": (_vm.proposta.dt_assinatura_convenio)
    },
    on: {
      "change": function($event) {
        return _vm.dataFinalVigencia()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "dt_assinatura_convenio", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
    staticClass: "required-field col-md-3 required",
    class: {
      'has-error': _vm.errors.first('periodo')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses de Execução do Projeto")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.nr_periodos),
      expression: "proposta.nr_periodos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Número de Meses do Projeto",
      "lang": "pt-br",
      "name": "periodo",
      "type": "number",
      "min": "1",
      "disabled": _vm.editando !== 'periodo_projeto'
    },
    domProps: {
      "value": (_vm.proposta.nr_periodos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data final de execução")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.dataFinal))])])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses de Vigência")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.periodo_vigencia),
      expression: "proposta.periodo_vigencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.proposta.nr_periodos),
      expression: "'required|min_value:' + proposta.nr_periodos"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Período Vigência",
      "lang": "pt-br",
      "name": "periodoVigencia",
      "type": "number",
      "max": "72",
      "min": _vm.proposta.nr_periodos,
      "disabled": _vm.editando !== 'periodo_projeto'
    },
    domProps: {
      "value": (_vm.proposta.periodo_vigencia)
    },
    on: {
      "change": function($event) {
        return _vm.dataFinalVigencia()
      },
      "keyup": function($event) {
        return _vm.dataFinalVigencia()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data final da vigência")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.proposta.dt_data_vigencia, "L")))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editando === 'periodo_projeto') ? _c('div', [_c('alteracoesPeriodoExecucao', {
    attrs: {
      "ParmProjetos": _vm.projeto,
      "ParmAlteracao": _vm.atProp,
      "filtro": _vm.filtro_alteracoes,
      "refreshTable": _vm.refreshAlteracoes,
      "cancelar": _vm.cancelar,
      "editando": _vm.editando,
      "permiteConcluir": _vm.permiteConcluir,
      "historicoAlteracaoPeriodo": _vm.historicoAlteracaoPeriodo,
      "editandoBloco": _vm.editandoBloco,
      "dataInicialAlteracao": _vm.proposta.dt_assinatura_convenio,
      "nr_periodos": _vm.proposta.nr_periodos,
      "dt_data_final": _vm.dataFinalExecucao,
      "periodo_vigencia": _vm.proposta.periodo_vigencia,
      "dt_data_vigencia": _vm.proposta.dt_data_vigencia
    },
    on: {
      "atualizarTimeline": function($event) {
        _vm.atualizar_timeline = $event
      }
    }
  })], 1) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'carteira_projeto') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.carteira = !_vm.mostrar.carteira
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.carteira ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Carteira")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Período de execução do projeto")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'carteira_projeto' && _vm.mostrar.carteira) ? _c('span', {
    staticClass: "opcaoAlterar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editar('carteira_projeto')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Será possível atribuir ou alterar a carteira deste projeto (somente disponível para Fundação)</h5>'
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.carteira) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Carteira Atual")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carteiraSelecionada),
      expression: "carteiraSelecionada"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.editavel || _vm.editando !== 'carteira_projeto'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carteiraSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Não encarteirado")]), _vm._v(" "), _vm._l((_vm.listaCarteiras), function(carteira) {
    return _c('option', {
      domProps: {
        "value": carteira.usu_codcart
      }
    }, [_vm._v(_vm._s(carteira.usu_codcart) + " - " + _vm._s(carteira.usu_nomcart))])
  })], 2)])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.avaliacao = !_vm.mostrar.avaliacao
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.avaliacao ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Avaliação de Projeto")])])]), _vm._v(" "), (_vm.mostrar.avaliacao) ? _c('div', {
    staticClass: "box-body"
  }, [_c('avaliacoes-projeto', {
    attrs: {
      "numeroProjeto": _vm.$route.params.numero,
      "editavel": _vm.editavel
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.mostrarRef('objetivo_especifico')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.objetivos = !_vm.mostrar.objetivos
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.objetivos ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Objetivo Específico")])])]), _vm._v(" "), (_vm.mostrar.objetivos) ? _c('div', {
    staticClass: "box-body"
  }, [_c('objetivo-especifico', {
    attrs: {
      "propsObjetivos": _vm.proposta.objetivos,
      "propsProposta": _vm.proposta
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.proposta.objetivos = $event
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
    ref: "metas"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.metas = !_vm.mostrar.metas
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.metas ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Metas")])])]), _vm._v(" "), (_vm.mostrar.metas) ? _c('div', {
    staticClass: "box-body"
  }, [_c('metas', {
    attrs: {
      "editavel": false,
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsProposta": _vm.proposta,
      "atvSemMetas": _vm.atvSemMetas
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.proposta.metas = $event
      },
      "validacaoMetas": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
    ref: "atividades"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.atividades = !_vm.mostrar.atividades
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.atividades ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atividades")])])]), _vm._v(" "), (_vm.mostrar.atividades) ? _c('div', {
    staticClass: "box-body"
  }, [_c('atividades', {
    attrs: {
      "editavel": false,
      "meses": _vm.proposta.nr_periodos,
      "propsMetas": _vm.proposta.metas,
      "propsAtividades": _vm.proposta.atividades,
      "propsProposta": _vm.proposta
    },
    on: {
      "atividadeAdicionada": function($event) {
        _vm.proposta.atividades = $event
      },
      "validacaoAtividades": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cronograma_fisicofinanceiro')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'cronograma') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.extratoProjeto = !_vm.mostrar.extratoProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.extratoProjeto ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Extrato do cronograma")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Extrato do cronograma")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'cronograma' && _vm.mostrar.extratoProjeto) ? _c('span', {
    staticClass: "opcaoAlterar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editar('cronograma')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Pode aumentar a quantidade de um item<br/>Essas alterações no SGP não alterarão o Sapiens</h5>'
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.extratoProjeto) ? _c('div', {
    staticClass: "box-body"
  }, [_c('extrato', {
    key: _vm.componentKey,
    attrs: {
      "editavel": _vm.editavel && _vm.editando === 'cronograma',
      "propsObjetivos": _vm.proposta.objetivos,
      "layout": 'classico',
      "etapa": 'VISUALIZACAO',
      "itensLayout": ['quantidade', 'contaFinanceira', 'idItem', 'filtroItens'],
      "propsAtividades": _vm.proposta.atividades,
      "metas": _vm.proposta.metas,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.nr_periodos,
      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao
    },
    on: {
      "cronogramaAtividades": function($event) {
        _vm.proposta.atividades = $event
      },
      "alteracoesCronograma": function($event) {
        _vm.cronogramaAlteracoes = $event
      },
      "validacaoCronograma": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  }), _vm._v(" "), _c('acertos-financeiros', {
    attrs: {
      "editavel": _vm.editavel && _vm.editando === 'acertos_financeiros',
      "numeroProjeto": this.$route.params.numero,
      "propsAtividades": _vm.proposta.atividades
    },
    on: {
      "alteracoesAcertosFinenceiros": function($event) {
        _vm.acertosFinanceirosAlteracoes = $event
      },
      "validacaoAcertosFinenceiros": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  }), _vm._v(" "), (_vm.mostrarRef('gantt')) ? _c('div', [_c('visualiza-gestao-atividades', {
    attrs: {
      "editavel": _vm.editavel && _vm.editando === 'gantt_atividades',
      "itensLayout": ['justificativa', 'opcoes'],
      "propsNumeroProjeto": _vm.$route.params.numero,
      "propsAtividades": _vm.proposta.atividades
    },
    on: {
      "atividadesProposta": function($event) {
        _vm.proposta.atividades = $event
      },
      "atividadesGantt": function($event) {
        _vm.proposta.gantt_atividades = $event
      },
      "atividadesAlteracoes": function($event) {
        _vm.proposta.gantt_alterado = $event
      },
      "validacaoAtividadesGantt": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'conta_adiantamento') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.contaAdiantamento = !_vm.mostrar.contaAdiantamento
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.contaAdiantamento ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                          Contas do Projeto")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hiden": "true"
    }
  }), _vm._v(" Contas do Projeto")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'conta_adiantamento' && _vm.mostrar.contaAdiantamento) ? _c('span', {
    staticClass: "opcaoAlterar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editar('conta_adiantamento')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>A conta de adiantamento pode ser alterada</h5>'
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.contaAdiantamento) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência (Para Adiantamento)")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|agency'),
      expression: "'required|agency'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": true,
      "name": "agencia de adiantamento",
      "mask": ['####-X'],
      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento'
    },
    model: {
      value: (_vm.dadosBancariosAdiantamento.agencia),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancariosAdiantamento, "agencia", $$v)
      },
      expression: "dadosBancariosAdiantamento.agencia"
    }
  }), _vm._v(" "), (_vm.errors.first('agencia de adiantamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia de adiantamento')) + "\n                          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Conta de Adiantamento")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|contacorrente'),
      expression: "'required|contacorrente'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": true,
      "name": "conta corrente de adiantamento",
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento'
    },
    model: {
      value: (_vm.dadosBancariosAdiantamento.conta),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancariosAdiantamento, "conta", $$v)
      },
      expression: "dadosBancariosAdiantamento.conta"
    }
  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("MCI")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosBancariosAdiantamento.mci),
      expression: "dadosBancariosAdiantamento.mci"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento',
      "type": "text"
    },
    domProps: {
      "value": (_vm.dadosBancariosAdiantamento.mci)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosBancariosAdiantamento, "mci", $event.target.value)
      }, _vm.limitarDigitosMCI]
    }
  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mci')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.contaAdiantamento) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência (Conta Interna)")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|agency'),
      expression: "'required|agency'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": true,
      "name": "agencia de adiantamento",
      "mask": ['####-X'],
      "disabled": ""
    },
    model: {
      value: (_vm.agenciaContaInterna),
      callback: function($$v) {
        _vm.agenciaContaInterna = $$v
      },
      expression: "agenciaContaInterna"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Conta Interna")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|contacorrente'),
      expression: "'required|contacorrente'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": true,
      "name": "conta corrente de adiantamento",
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
      "disabled": ""
    },
    model: {
      value: (_vm.contaInterna),
      callback: function($$v) {
        _vm.contaInterna = $$v
      },
      expression: "contaInterna"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Código Fornecedor")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codFor),
      expression: "codFor"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.codFor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codFor = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.proposta.intervencao_bndes) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número Intervenção BNDES")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.intervencao_bndes),
      expression: "proposta.intervencao_bndes"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.proposta.intervencao_bndes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "intervencao_bndes", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('parcelas_adiantamento')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.parcelasAdiantamento = !_vm.mostrar.parcelasAdiantamento
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.parcelasAdiantamento ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Parcelas de Adiantamento")])])]), _vm._v(" "), (_vm.mostrar.parcelasAdiantamento) ? _c('div', {
    staticClass: "box-body"
  }, [_c('parcela-adiantamento', {
    attrs: {
      "editavel": false,
      "propsProposta": _vm.proposta,
      "propsParcelas": _vm.proposta.adiantamentos,
      "propsAtividades": _vm.proposta.atividades,
      "propsLayout": 'EXECUCAO'
    },
    on: {
      "parcelaAdicionada": function($event) {
        _vm.proposta.adiantamentos = $event
      },
      "validacaoParcelasAdiantamento": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'publicos_alvo') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.publicoAlvo = !_vm.mostrar.publicoAlvo
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.publicoAlvo ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Público-alvo")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Público-alvo")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'publicos_alvo' && _vm.mostrar.publicoAlvo) ? _c('span', {
    staticClass: "opcaoAlterar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editar('publicos_alvo')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Público-alvo pode ser acrescentado, mas não alterado o que foi contratado para não divergir do informado em relatórios de atividades anteriores<br/>Ao concluir o SGP alterará o Sapiens também</h5>'
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
    staticClass: "box-body"
  }, [_c('publico-alvo', {
    attrs: {
      "editavel": _vm.editavel && _vm.editando === 'publicos_alvo',
      "propsPublicosGrid": _vm.proposta.publicos_alvo
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.proposta.publicos_alvo = $event
      },
      "validacaoPublicoAlvo": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(3), _vm._v(" "), _c('publicoAlvoDescricao', {
    ref: "publicoAlvoDescricao",
    attrs: {
      "proposta": _vm.proposta.id,
      "fixado": false,
      "permiteEditar": true,
      "abrirAbas": true,
      "telaProjeto": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(4), _vm._v(" "), _c('publicoAlvoDescricaoRealizado', {
    ref: "publicoAlvoDescricaoRealizado",
    attrs: {
      "proposta": _vm.proposta.id,
      "fixado": false,
      "abrirAbas": false
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'municipalizacao') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.tecnologiaSocial = !_vm.mostrar.tecnologiaSocial
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.tecnologiaSocial ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Tecnologia Social")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Tecnologia Social")])])]), _vm._v(" "), (_vm.mostrar.tecnologiaSocial) ? _c('div', {
    staticClass: "box-body"
  }, [_c('tecnologiaSocial', {
    ref: "tecnologiaSocial",
    attrs: {
      "proposta": _vm.proposta.id,
      "fk_processo": _vm.proposta.fk_processo,
      "telaProjeto": true
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo') && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'municipalizacao') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.ods = !_vm.mostrar.ods
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.ods ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" ODS - Objetivos de Desenvolvimento Sustentável ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" ODS - Objetivos de Desenvolvimento Sustentável")])])]), _vm._v(" "), (_vm.mostrar.ods) ? _c('div', {
    staticClass: "box-body"
  }, [_c('odsMarcacao', {
    attrs: {
      "proposta": _vm.proposta.id,
      "telaProjeto": true
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('municipios')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.municipios = !_vm.mostrar.municipios
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.municipios ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Municípios - Locais de execução")])])]), _vm._v(" "), (_vm.mostrar.municipios) ? _c('div', {
    staticClass: "box-body"
  }, [_c('municipalizacao', {
    attrs: {
      "editavel": false,
      "propsProposta": _vm.proposta
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.proposta.municipalizacao = $event
      },
      "validacaoMunicipio": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.editando !== 'coordenador') ? _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.coordenador = !_vm.mostrar.coordenador
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.coordenador ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Responsável pela Proposta")]) : _c('span', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Responsável pela Proposta")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'coordenador' && _vm.mostrar.coordenador) ? _c('span', {
    staticClass: "opcaoAlterar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editar('coordenador')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Qualquer informação abaixo relativo ao Responsável pela Proposta pode ser alterado<br/><br/>Após Concluir, Esta alteração será enviada automaticamente ao Sapiens</h5>'
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.coordenador) ? _c('div', {
    staticClass: "box-body form-group"
  }, [(_vm.mostrarRef('coordenador_nome')) ? _c('div', {
    staticClass: "required-field col-md-8 required",
    class: {
      'has-error': _vm.errors.first('nome do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_nome_coordenador),
      expression: "proposta.ds_nome_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text",
      "data-vv-as": "Nome do Coordenador",
      "maxlength": "100",
      "disabled": _vm.editando !== 'coordenador'
    },
    domProps: {
      "value": (_vm.proposta.ds_nome_coordenador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_nome_coordenador", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_cpf')) ? _c('div', {
    staticClass: "required-field col-md-4 required",
    class: {
      'has-error': _vm.errors.first('cpf do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf"
    }
  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "data-vv-as": "CPF do Coordenador",
      "disabled": _vm.editando !== 'coordenador',
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.proposta.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
      },
      expression: "proposta.ds_cpf_coordenador"
    }
  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "disabled": _vm.editando !== 'coordenador',
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.proposta.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
      },
      expression: "proposta.ds_cpf_coordenador"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_email')) ? _c('div', {
    staticClass: "required-field col-md-6 required",
    class: {
      'has-error': _vm.errors.first('email do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_email_coordenador),
      expression: "proposta.ds_email_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:255'),
      expression: "'required|email|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editando !== 'coordenador',
      "name": "ds_email_coordenador",
      "type": "email",
      "data-vv-as": "E-mail do Coordenador",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_email_coordenador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_email_coordenador", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_telefone')) ? _c('div', {
    staticClass: "col-md-3 required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "data-vv-as": "Telefone do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####'],
      "disabled": _vm.editando !== 'coordenador'
    },
    model: {
      value: (_vm.proposta.ds_telefone_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_telefone_coordenador", $$v)
      },
      expression: "proposta.ds_telefone_coordenador"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_celular')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "data-vv-as": "Celular do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####'],
      "disabled": _vm.editando !== 'coordenador'
    },
    model: {
      value: (_vm.proposta.ds_celular_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_celular_coordenador", $$v)
      },
      expression: "proposta.ds_celular_coordenador"
    }
  })], 1)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.cursos = !_vm.mostrar.cursos
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.cursos ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cursos")])])]), _vm._v(" "), (_vm.mostrar.cursos) ? _c('div', {
    staticClass: "box-body"
  }, [_c('cursos', {
    attrs: {
      "propsCursos": _vm.proposta.cursos
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('equipe_do_projeto')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.equipeProjeto = !_vm.mostrar.equipeProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.equipeProjeto ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Equipe do Projeto")])])]), _vm._v(" "), (_vm.mostrar.equipeProjeto) ? _c('div', {
    staticClass: "box-body"
  }, [(_vm.entidadeEhFundacao) ? _c('span', {
    staticClass: "col-md-12 entidadeEhFundacao"
  }, [_vm._v("\n                          Dispensado registro pela proponente Fundação BB\n                        ")]) : _c('span', [_c('equipe-projeto', {
    attrs: {
      "propsEquipes": _vm.proposta.equipes
    },
    on: {
      "equipeAdicionada": function($event) {
        _vm.proposta.equipes = $event
      }
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.informacoesProjeto = !_vm.mostrar.informacoesProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.informacoesProjeto ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Informações do Projeto")])])]), _vm._v(" "), (_vm.mostrar.informacoesProjeto) ? _c('div', {
    staticClass: "box-body"
  }, [(_vm.mostrarRef('informacoes_introdutorias_introducao')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "introducao",
      "data-vv-as": "Informações Introdutórias do Projeto",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_introducao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_introducao", $$v)
      },
      expression: "proposta.ds_introducao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_apresentacao')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Apresentação do Projeto",
      "name": "apresentacao",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
      },
      expression: "proposta.ds_apresentacao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_territorio')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Território de Desenvolvimento do Projeto",
      "name": "territorio",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_territorio),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_territorio", $$v)
      },
      expression: "proposta.ds_territorio"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_justificativa')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Justificativa do Projeto",
      "name": "justificativa",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_justificativa),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
      },
      expression: "proposta.ds_justificativa"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_objetivo_geral')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Objetivo Geral do Projeto",
      "name": "objetivo Geral",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_objetivo_geral),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
      },
      expression: "proposta.ds_objetivo_geral"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_resultados')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Resultados Esperados do Projeto",
      "name": "Resultados esperados",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_resultados),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_resultados", $$v)
      },
      expression: "proposta.ds_resultados"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_operacionalizacao')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Operacionalização do Projeto",
      "name": "Operacionalização",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_operacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_operacao", $$v)
      },
      expression: "proposta.ds_operacao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_parceria')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Parceria do Projeto",
      "name": "Parceria",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_parceria),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_parceria", $$v)
      },
      expression: "proposta.ds_parceria"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_resumo')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "data-vv-as": "Resumo do Projeto",
      "name": "sumario",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_resumo),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_resumo", $$v)
      },
      expression: "proposta.ds_resumo"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_acoes')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ",
    attrs: {
      "disabled": true,
      "data-vv-as": "indicadores",
      "name": "acoes",
      "rows": "4"
    },
    model: {
      value: (_vm.proposta.ds_acoes_comunicacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
      },
      expression: "proposta.ds_acoes_comunicacao"
    }
  })], 1)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.analiseProjeto = !_vm.mostrar.analiseProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.analiseProjeto ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Análise do Projeto")])])]), _vm._v(" "), (_vm.mostrar.analiseProjeto) ? _c('div', {
    staticClass: "box-body"
  }, [_c('analise', {
    ref: "child",
    attrs: {
      "propsAnalise": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "analiseProposta": function($event) {
        _vm.analise = $event
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('documentos')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.documentos = !_vm.mostrar.documentos
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.documentos ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Documentos da Proposta")])])]), _vm._v(" "), (_vm.mostrar.documentos) ? _c('div', {
    staticClass: "box-body"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosProposta,
      "documentTypes": _vm.proposta.tipoDocumentos,
      "localUso": 'PROPOSTA_COMPLETA_DOCUMENTOS_ANEXOS',
      "propsEtapa": _vm.nulo
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('historico')) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.historico = !_vm.mostrar.historico
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.historico ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Histórico")])])]), _vm._v(" "), (_vm.mostrar.historico) ? _c('div', {
    staticClass: "box-body"
  }, [_c('historico-proposta', {
    attrs: {
      "proposta": _vm.proposta
    },
    on: {
      "historico_itens": function($event) {
        _vm.historico_atualizado = $event
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (false && _vm.mostrarRef('entidade_executora_proponente')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityIsExecutioner"
    }
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_entidade_executora),
      expression: "proposta.bt_entidade_executora"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-true",
      "value": "true",
      "selected": _vm.proposta.entityIsExecutioner === 'true',
      "disabled": true
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "bt_entidade_executora", "true")
      }
    }
  }), _vm._v(" Sim\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_entidade_executora),
      expression: "proposta.bt_entidade_executora"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-false",
      "value": "false",
      "selected": _vm.proposta.entityIsExecutioner === 'false',
      "disabled": true
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "bt_entidade_executora", "false")
      }
    }
  }), _vm._v(" Não\n                            ")])])]), _vm._v(" "), (_vm.proposta.bt_entidade_executora === 'false') ? _c('div', [_c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    attrs: {
      "disabled": true
    }
  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field  col-md-12",
    class: {
      'has-error': _vm.errors.first('Nome Entidade Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_nome),
      expression: "proposta.ds_entidade_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nome Entidade Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Representante legal')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingProcurator"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_representante_legal),
      expression: "proposta.ds_entidade_representante_legal"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_representante_legal'),
      expression: "'required:!proposta.ds_entidade_representante_legal'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Representante legal",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_representante_legal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_representante_legal", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ entidade executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCNPJ"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_cnpj|cnpj'),
      expression: "'required:!proposta.ds_entidade_cnpj|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ entidade executora",
      "type": "text",
      "mask": ['##.###.###/####-##']
    },
    model: {
      value: (_vm.proposta.ds_entidade_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_cnpj", $$v)
      },
      expression: "proposta.ds_entidade_cnpj"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    attrs: {
      "disabled": true
    }
  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('E-mail executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_email),
      expression: "proposta.ds_entidade_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_email|email'),
      expression: "'required:!proposta.ds_entidade_email|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "E-mail executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingPhone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_telefone'),
      expression: "'required:!proposta.ds_entidade_telefone'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.ds_entidade_telefone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_telefone", $$v)
      },
      expression: "proposta.ds_entidade_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone celular da executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingMobile"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_celular'),
      expression: "'required:!proposta.ds_entidade_celular'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone celular da executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.ds_entidade_celular),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_celular", $$v)
      },
      expression: "proposta.ds_entidade_celular"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    attrs: {
      "disabled": true
    }
  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CEP da executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCEP"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CEP da executora",
      "type": "text",
      "mask": ['#####-###']
    },
    model: {
      value: (_vm.proposta.entityExecutingCEP),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
      },
      expression: "proposta.entityExecutingCEP"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('UF executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingState),
      expression: "proposta.entityExecutingState"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UF executora"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.estados), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Cidade da Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCity"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingCity),
      expression: "proposta.entityExecutingCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cidade da Executora",
      "type": "text"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Endereço da Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingAddress"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingAddress),
      expression: "proposta.entityExecutingAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Endereço da Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Timeline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Banco (Para Adiantamento)")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("001 - Banco do Brasil")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Banco (Conta Interna)")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("001 - Banco do Brasil")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Previsto")]), _vm._v(":")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Realizado")]), _vm._v(":")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entidade executora")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81d3325a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/Projeto.vue
// module id = 1928
// module chunks = 2